import { createIcon } from '../icon'
import RattingSizeIcon from '@/components/atoms/svg/RattingSizeColor'

export const RattingSizeIconDefault = createIcon(RattingSizeIcon)
